export const isProdClient = () => !location.hostname.includes('localhost');
